// importaciones de vue-router
import { type RouteLocationNormalized } from 'vue-router';

export const validateNavigation = (
  to: RouteLocationNormalized,
  from: RouteLocationNormalized
) => {
  if (to.meta.requiresNavigationFrom) {
    const allowedRoutes = to.meta.requiresNavigationFrom as string[];

    if (!allowedRoutes.includes(from.name as string)) {
      return { name: allowedRoutes[0] };
    }
  }

  return true;
};
